module.exports = __webpack_public_path__ + "img/ayuda-figura2-centroides.0d3bbcbc.png";